import { render } from "./AllExpensesView.vue?vue&type=template&id=6a00cee2"
import script from "./AllExpensesView.vue?vue&type=script&lang=js"
export * from "./AllExpensesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__